import { trackBusinessError } from '@sxm-de/dev-kits/web-sdk/utils';
import { DependenciesPayload } from '@sxm-de/dev-kits/web-sdk/types';

export async function CreateBillingProfileWithDefaultPaymentMethod(
    {
        firstName,
        lastName,
        serviceAddress,
        stripePaymentMethodId,
    }: {
        firstName: string;
        lastName: string;
        serviceAddress: {
            addressLine1?: string;
            city?: string;
            state?: string;
            zipCode: string;
            country: string;
        };
        stripePaymentMethodId: string;
    },
    { clientSdk, appEventSdk }: DependenciesPayload,
): Promise<void> {
    const billingProfileName = {
        firstAndLastName: {
            firstName,
            lastName,
        },
    };

    try {
        await clientSdk.commerce.billing.createBillingProfile({
            billingProfileName,
            serviceAddress: {
                ...serviceAddress,
                country: serviceAddress.country.toUpperCase(),
            },
            stripePaymentMethodId,
        });
    } catch (error: any) {
        if (
            error?.code ===
                'commerceTeam.billingServiceService.payment_method_failed' ||
            error?.code ===
                'commerceTeam.billingServiceService.payment_method_declined'
        ) {
            trackBusinessError(appEventSdk, error);
            throw new Error('CREDIT_CARD_ERROR');
        } else {
            /**
             * TODO:
             * Log error to error logger (not analytics).
             */
            throw new Error('SYSTEM');
        }
    }
}
